import { Facebook, Linkedin, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" aria-hidden="true" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" aria-hidden="true" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" />
  </svg>
);

export function ShareButtons({ title = "" }) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);

  const links = [
    { key: "whatsapp", label: "Share on WhatsApp", Icon: WhatsAppIcon, href: `https://wa.me/?text=${t}%20${u}`, hover: "hover:bg-[#25D366] hover:border-[#25D366]" },
    { key: "facebook", label: "Share on Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, hover: "hover:bg-[#1877F2] hover:border-[#1877F2]" },
    { key: "twitter", label: "Share on X", Icon: XIcon, href: `https://twitter.com/intent/tweet?url=${u}&text=${t}`, hover: "hover:bg-black hover:border-black" },
    { key: "linkedin", label: "Share on LinkedIn", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, hover: "hover:bg-[#0A66C2] hover:border-[#0A66C2]" },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy link");
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
      <span className="text-xs uppercase tracking-[0.18em] text-brand-muted font-semibold mr-1">Share</span>
      {links.map(({ key, label, Icon, href, hover }) => (
        <a key={key} href={href} target="_blank" rel="noreferrer noopener" aria-label={label} data-testid={`share-${key}`}
          className={`w-9 h-9 flex items-center justify-center rounded-full border border-brand/15 text-brand text-lg transition-colors hover:text-white ${hover}`}>
          <Icon />
        </a>
      ))}
      <button onClick={copy} aria-label="Copy link" data-testid="share-copy"
        className="w-9 h-9 flex items-center justify-center rounded-full border border-brand/15 text-brand hover:bg-brand hover:text-white transition-colors">
        {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
      </button>
    </div>
  );
}
